import request from "@/CommonDP/utils/request";
const PRJ_PREFIX = '/prjRole'
const DICT_PREFIX = '/dic/content/list'
export default {
    getPrjRoleTree(enterpriseId) {
        // debugger
        return request.get(`${PRJ_PREFIX}/tree?enterpriseId=${enterpriseId}`)
    },
    getPrjRoleTreeByPrj(prjId) {
        return request.get(`${PRJ_PREFIX}/tree?prjId=${prjId}`)
    },
    getPrjRoleTreeByPrjNew(prjId) {
        return request.get(`${PRJ_PREFIX}/role/tree?prjId=${prjId}`)
    },
    /**新增分类 */
    addItem(params) {
        return request.post(`${PRJ_PREFIX}/addItem`, params)
    },
    /**新增角色 */
    addRole(params) {
        return request.post(`${PRJ_PREFIX}/add`, params)
    },
    /**获得角色字典 */
    getRoleDict() {
        return request.get(`${DICT_PREFIX}?dicCode=RoleItem`)
    },

    /**获得业态字典 */
    getFormatDict() {
        return request.get(`${DICT_PREFIX}?dicCode=PrjType`)
    },

    deleteRole(roleId) {
        return request.post(`${PRJ_PREFIX}/delete?roleId=${roleId}`)
    },

    updateRole(params) {
        return request.post(`${PRJ_PREFIX}/update`, params)
    },

    deleteClass(specId) {
        return request.post(`${PRJ_PREFIX}/deleteItem?specId=${specId}`)
    },

    updateClass(params) {
        return request.post(`${PRJ_PREFIX}/updateItem`, params)
    }

}